import * as classes from './Notification.module.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const Notification = ({ content, enable = false }) => {
  return (
    <>
      {content && enable && (
        <section className={classes.notification}>
          <div className="container-text container-sm">
            {documentToReactComponents(content)}
          </div>
        </section>
      )}
    </>
  )
}

export default Notification
